var React = require('react');

function IconCloudComment (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"#F54B26","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","d":"M33,1.3c17.5,0,31.7,12.9,31.7,28.7c-0.1,7.6-3.3,14.8-8.9,19.9l8.9,8.8H33\n\tC15.5,58.7,1.3,45.9,1.3,30S15.5,1.3,33,1.3z","key":0}),React.createElement("path",{"fill":"none","stroke":"#F54B26","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","d":"M33,31.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4S32.2,31.4,33,31.4z\n\t M46.8,31.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4S46,31.4,46.8,31.4z M19.2,31.4c0.8,0,1.4-0.6,1.4-1.4\n\ts-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4S18.4,31.4,19.2,31.4z","key":1})]);
}

IconCloudComment.defaultProps = {"width":"66px","height":"60px","viewBox":"0 0 66 60"};

module.exports = IconCloudComment;

IconCloudComment.default = IconCloudComment;
